/**
 * PostHog session recording is enabled ONLY in the deployed dev environment
 * (NEXT_PUBLIC_RUNTIME_ENVIRONMENT === "caruso-dev", which also covers PR
 * preview deploys, since previews load the caruso-dev env files). Staging,
 * production, production-au, local and CI keep it OFF.
 *
 * Project decision D8: recording is dev-only so it never captures real clients
 * or investors — dev is staff-only. PostHog itself initialises wherever
 * NEXT_PUBLIC_POSTHOG_ENABLED === "1" (currently dev AND production), so the
 * environment name is the correct, independent discriminator for the dev-only
 * carve-out: enabling PostHog events in prod must never turn recording on.
 *
 * maskAllInputs + maskTextSelector are always on wherever recording runs, so a
 * recording can never contain typed field contents or on-screen text.
 */
export const SESSION_RECORDING_ENVIRONMENT = "caruso-dev";

export interface PosthogSessionRecordingConfig {
	disable_session_recording: boolean;
	session_recording: {
		maskAllInputs: boolean;
		maskTextSelector: string;
	};
}

export function posthogSessionRecordingConfig(
	runtimeEnvironment: string | undefined,
): PosthogSessionRecordingConfig {
	return {
		disable_session_recording:
			runtimeEnvironment !== SESSION_RECORDING_ENVIRONMENT,
		session_recording: {
			maskAllInputs: true,
			maskTextSelector: "*",
		},
	};
}
